module.exports = __webpack_public_path__ + "img/hopos--the-journal-of-the-international-society-for-the-history-of-philosophy-of-science-cover.94e10e17.jpg";